var exports = {
  "container": "xfd349460--4616d1--container",
  "image": "xfd349460--4616d1--image",
  "not-found": "xfd349460--4616d1--not-found",
  "start": "xfd349460--4616d1--start",
  "title": "xfd349460--4616d1--title",
};

module.exports = exports;
